/* eslint-disable */

import type { RecipesLang } from "./types/RecipesLang";

let data: RecipesLang | undefined;

export type { RecipesLang };

export default function RecipesLangFactory(): RecipesLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setRecipesLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/RecipesLangDef").then(({ RecipesLangDef }) => {
      data = RecipesLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/RecipesLangDef").then(({ RecipesLangDef }) => {
      data = RecipesLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/RecipesLangDef").then(({ RecipesLangDef }) => {
      data = RecipesLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/RecipesLangDef").then(({ RecipesLangDef }) => {
      data = RecipesLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

